<template>
    <div class="content-page">
        <div class="container-fluid add-form-list">
            <div class="row">
                <div class="col-sm-12">
                    <div class="card">
                        <div class="card-header d-flex justify-content-between">
                            <div class="header-title">
                                <h4 class="card-title">Details de type de repas </h4>
                            </div>
                        </div>
                        <div class="card-body">
                            <form @submit.prevent="update" data-toggle="validator">
                                <div class="row">
                                    <div class="col-md-12">
                                        <div class="form-group">
                                            <label>Title*</label>
                                            <input type="text" v-model="type.libelle" class="form-control" placeholder="Enter libelle" readonly required>
                                        </div>
                                    </div>
                                    
                                    <div class="col-md-12">
                                        <div class="form-group">
                                            <label>Description*</label>
                                            <input type="text" v-model="type.description" class="form-control" placeholder="Enter libelle" readonly>
                                        </div>
                                    </div>                          
                                </div> 

                                <div class="row">
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label>Coût *</label>
                                            <input type="number" v-model="type.price" class="form-control" placeholder="Enter coût" readonly required>
                                            <div class="help-block with-errors"></div>
                                        </div>
                                    </div>  
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label>Type *</label>
                                            <select class="form-control"  v-model="type.parent_id" id="" readonly>
                                                <option v-for="(selectTy,index) in typeSelect" :key="index" :value="selectTy.id">{{selectTy.libelle}}</option>
                                            </select>
                                            <div class="help-block with-errors"></div>
                                        </div>
                                    </div>  
                                </div>                         
                                <button class="btn btn-primary mr-2" v-if="permissions.includes('edit-meal-types')">Modifier</button>
                                <a class="btn btn-primary mr-2" @click="$router.go(-1)">Retour</a>
                            </form>
                        </div>
                    </div>
                    <div class="vld-parent">
                        <loading :active.sync="isLoading" 
                        :can-cancel="true" 
                        :is-full-page="fullPage"></loading>
                    </div>
                </div>
            </div>
            <!-- Page end  -->
        </div>
    </div>
</template>
<script>
import axios from "axios";
import {URL_API} from '@/config'
// Import component
import Loading from 'vue-loading-overlay';
// Import stylesheet
import 'vue-loading-overlay/dist/vue-loading.css';


export default {
    components: {
            Loading
    },
    data() {
        return {permissions: [],
            type:{},
            typeSelect:[],
            isLoading: false,
            fullPage: true,
            
        };
    },
    mounted(){this.$store.state.user.permissions.forEach(element => {
            this.permissions.push(element.name)
        });
        this.getType()
        this.getTypes()
    },

    methods:{
        getType() {
            this.isLoading = true
            axios.get(URL_API+'types-repas/'+this.$route.params.id)
            .then(response => {
                
                console.log(response)
                
                if (response.data.status) {
                    
                    this.type = response.data.data
                this.isLoading = false
                }
            })
            .catch(error => {
                console.log(error)
                this.errored = true
                this.isLoading = false
            })
        },
        getTypes() {
            this.isLoading = true
            axios.get(URL_API+'types-repas', this.type)
            .then(response => {
                
                console.log(response.data)
                this.isLoading = false
                
                if (response.data.status) {
                    this.typeSelect =  response.data.data
                }
            })
            .catch(error => {
                console.log(error)
                this.errored = true
                this.isLoading = false
            })
        },
        update(){
            this.$router.push('/edit-type-repas/'+this.$route.params.id)
        }
    }
}
</script>